import { Fragment, useContext, useState, useRef, useEffect, useCallback } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { EntityContext } from '../../context/EntityContext';
import { APIGetAllAccess } from '../../api/access/Access';
import {TfiClose} from "react-icons/tfi";
import { LinkShare } from '../share/linkShare';
import { CredentialsShare } from '../share/credentialsShare';
import { AccountShare } from '../share/accountShare';

export const ShareModal = () => {
    const cancelButtonRef = useRef(null);
    const { openShareModal, setOpenShareModal, currentEntity, currentSetting} = useContext(EntityContext);
    const [loading, setLoading] = useState(false);
    const [currentTab, setCurrentTab] = useState('Zugangsdaten');
    const [accessDataLink, setAccessDataLink] = useState(null);
    const [accessDataCredentials, setAccessDataCredentials] = useState(null);
    const [accessDataAccount, setAccessDataAccount] = useState(null);
    // TODO: implement more share types
    const entityType = currentSetting.type === 'myPlans' ? 'plan' : '';

    //console.log('ShareModal', currentEntity, currentSetting);

    const tabs = ['Zugangsdaten', 'Link']; //'Benutzer'

    const onFinish = async () => {
        setOpenShareModal(false);
        setLoading(false);
        return true;
    }

    const onShareCancel = async () => {
        setLoading(true);
        setOpenShareModal(false);
        setLoading(false);
    }

    const fetchAccessData = useCallback(async () => {
        if (currentEntity?.id) {
            const accessData = await APIGetAllAccess(currentEntity.id, entityType);
            if (accessData) {
                setAccessDataLink(accessData.accessLink);
                setAccessDataCredentials(accessData.accessCredentials);
                setAccessDataAccount(accessData.accessAccount);
            } else {
                setAccessDataLink(null);
                setAccessDataCredentials(null);
                setAccessDataAccount(null);
            }
        }
    }, [currentEntity, entityType]);

    useEffect(() => {
        fetchAccessData();
    }, [fetchAccessData]);

    return (
        <Transition.Root show={openShareModal} as={Fragment}>
            <Dialog
            className="relative z-10"
            initialFocus={cancelButtonRef}
            onClose={onShareCancel}
            >
            <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
    
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex h-full items-center justify-center sm:px-4 sm:pb-4 text-center pt-[65px] sm:px-4 lg:p-10 max-w-5xl mx-auto">
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <Dialog.Panel className='flex flex-col max-h-full sm:max-h-max h-full rounded-lg bg-white text-left shadow-xl transition-all w-full relative'>
                    <button
                        type='button'
                        className='absolute z-40 lg: lg:-top-6 lg:-right-6 top-2 right-2'
                        onClick={onShareCancel}
                        disabled={loading}
                        ref={cancelButtonRef}
                    >
                        <TfiClose className={"lg:size-16 border-gray-500/80 border-2 bg-white hover:bg-gray-300 lg:p-4 size-12 p-2 lg:rounded-full rounded-md"}/>
                    </button>
                    <div className='block md:flex w-full md:overflow-hidden'>
                        <div className=' rounded-tl-lg rounded-bl-lg py-8 px-8 md:flex w-full md:w-2/5 bg-gray-900 flex-col'>
                            <div>
                                <div className='flex items-center  md:mb-8 gap-2'>
                                    <Dialog.Title
                                        as='h3'
                                        className='font-bold text-2xl leading-6 text-white'>
                                        Plan teilen
                                    </Dialog.Title>
                                </div>
                            </div>
        
                            <div className={'h-auto md:h-[450px] '}>
                                <div className='h-full w-full pt-4 pb-8 '>
                                    <div className='relative flex flex-col items-start pl-[0px] justify-between text-white/70 h-full'>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'md:w-3/5 flex bg-white flex-col w-full'}>
                            <div className='px-8 pt-8 flex flex-col overflow-hidden'>
                                <div className="grid grid-cols-1 sm:hidden">
                                    <select
                                        defaultValue={tabs.find((tab) => tab === currentTab ? tab : tabs[0])}
                                        onChange={(e) => setCurrentTab(e.target.value)}
                                        aria-label="Select a tab"
                                        className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                                    >
                                        {tabs.map((tab, index) => (
                                            <option key={index}>{tab}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="hidden sm:block">
                                    <div className="border-b border-gray-400">
                                        <nav aria-label="Tabs" className="-mb-px flex space-x-8">
                                            {tabs.map((tab) => (
                                                <div
                                                    key={tab}
                                                    className={`${tab === currentTab ? 'border-gray-900 text-gray-900' : 'border-transparent text-gray-600/60 hover:border-gray-400 hover:text-gray-900'} whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium cursor-pointer`}
                                                    onClick={() => setCurrentTab(tab)}
                                                >
                                                    {tab}
                                                </div>
                                            ))}
                                        </nav>
                                    </div>
                                </div>
                            </div>
                            <div className={'flex flex-col flex-1 overflow-hidden'}>
                                <div className={'overflow-y-auto h-full w-full'}>
                                    <div className={'flex flex-col gap-4 p-8 h-[500px]'}>
                                        {currentTab === 'Benutzer' && (
                                            <AccountShare accessData={accessDataAccount} setAccessData={setAccessDataAccount} entityId={currentEntity.id} entityType={entityType} fetchAccessData={fetchAccessData}/>
                                        )}
                                        {currentTab === 'Zugangsdaten' && (
                                            <CredentialsShare accessData={accessDataCredentials} setAccessData={setAccessDataCredentials} entityId={currentEntity.id} entityType={entityType}/>
                                        )}
                                        {currentTab === 'Link' && (
                                            <LinkShare accessData={accessDataLink} setAccessData={setAccessDataLink} entityId={currentEntity.id} entityType={entityType}/>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="p-8 sm:flex-row-reverse flex w-full flex-col-reverse gap-4">
                                <button
                                    type="button"
                                    disabled={loading}
                                    className={`${loading ? 'cursor-progress' : ''} text-center truncate items-center rounded-md bg-white border-gray-900 border-2 disabled:text-gray-600/40 disabled:border-gray-500 px-4 py-3 text-sm font-semibold text-gray-900 `}
                                    onClick={onFinish}
                                >
                                    Fertig
                                </button>
                            </div>
                        </div>
                    </div>
                    </Dialog.Panel>
    
                </Transition.Child>
                </div>
            </div>
            </Dialog>
        </Transition.Root>
    );
}
